"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllianceLeadFilters = void 0;
const typebox_1 = require("@sinclair/typebox");
const alliance_lead_transport_1 = require("./alliance-lead-transport");
const customer_type_1 = require("./customer-type");
exports.AllianceLeadFilters = typebox_1.Type.Partial(typebox_1.Type.Object({
    firstName: typebox_1.Type.String(),
    lastName: typebox_1.Type.String(),
    company: typebox_1.Type.String(),
    email: typebox_1.Type.String(),
    phoneNumber: typebox_1.Type.String(),
    customerID: typebox_1.Type.String(),
    motivation: typebox_1.Type.String(),
    followUpDateAfter: typebox_1.Type.String(),
    followUpDateBefore: typebox_1.Type.String(),
    channel: typebox_1.Type.String(),
    customerType: customer_type_1.CustomerType,
    type: alliance_lead_transport_1.LeadType,
    status: alliance_lead_transport_1.LeadStatus,
    requestedDeliveryDateAfter: typebox_1.Type.String(),
    requestedDeliveryDateBefore: typebox_1.Type.String(),
    requestedMaterial: typebox_1.Type.String(),
    reasonLost: typebox_1.Type.String(),
    currentHauler: typebox_1.Type.String(),
    requestedStartDateAfter: typebox_1.Type.String(),
    requestedStartDateBefore: typebox_1.Type.String(),
    needsAttention: typebox_1.Type.Boolean(),
    affiliateTrackingID: typebox_1.Type.String(),
    createdAfter: typebox_1.Type.String(),
    createdBefore: typebox_1.Type.String(),
    limit: typebox_1.Type.Number(),
    offset: typebox_1.Type.Number(),
    sortBy: typebox_1.Type.String(),
    sortOrder: typebox_1.Type.String(),
}));
//# sourceMappingURL=alliance-lead-filters.js.map